<template>
  <div class="demo-page">
    <dl>
      <dt>
        <h2>Alert</h2>
      </dt>
      <dd>
        <CustomAlert />
      </dd>
    </dl>
  </div>
</template>

<script>
import CustomAlert from './views/Alert'

export default {
  components: {
    CustomAlert
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/css/pc.scss';
.demo-page {
  padding: 24px;
  h2 {
    padding: 12px 0;
    font-size: 20px;
    font-weight: bold;
  }
}
</style>
